import MuiFormControlLabel, {
  FormControlLabelProps as MuiFormControlLabelProps,
} from '@mui/material/FormControlLabel';

export type FormControlLabelProps = MuiFormControlLabelProps;

export const FormControlLabel: React.FC<FormControlLabelProps> = (props) => (
  <MuiFormControlLabel {...props} />
);
